import edytowanieService from '../../services/edytowanieService'

const state = {
    edytowane: []
}
const initialState = {
    edytowane: []    
}


const getters = {
    edytowane: state => {
        return state.edytowane
    }
}
const actions = {
    getEdytowane({commit}, params) {
        return new Promise((resolve,reject)=>{
            edytowanieService.fetchEdytowanie(params).then((res) => {
            commit('setEdytowane', res)
            resolve(res)
        }).catch((error) => { 
            console.log( "error" +JSON.stringify(error.response.data))
            reject(error)
      })
        })
    },
    postEdytowane({commit}, params){
        return new Promise((resolve, reject)=>{
            edytowanieService.postEdytowanie(params)        
                .then((response) => {
                    // commit('postEdytowany', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    //usuwanie po id parametr id_wpisu
    deleteEdytowane({commit}, params){
        return new Promise((resolve, reject)=>{
            edytowanieService.deleteEdytowanie(params)        
                .then((response) => {
                    // commit('deleteEdyt', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    //usuwanie wszystkich
    deleteEdytowaneAll({commit}){
        return new Promise((resolve, reject)=>{
            edytowanieService.deleteAllEdytowania()        
                .then((response) => {
                    // commit('deleteEdytowania', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
}
const mutations = {
    setEdytowane (state, res) {
        state.edytowane = res
    },
   
    
}
export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}